exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#ruler {\n  box-sizing: border-box;\n  border-right: solid 2px black;\n}\n.rulerTicksCell {\n  box-sizing: border-box;\n  background-color: white;\n\n  text-align: right;\n}\n.tickTop {\n}\n.ticksMain {\n  border-top-style: solid;\n  border-top-width: 2px;\n  border-top-color: black;\n}\n.ticksSub {\n  border-top-style: dotted;\n  border-top-width: 2px;\n  border-top-color: #cccccc;\n\n  font-size: 14px;\n  color: #cccccc;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3854584e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/Ruler.vue
// module id = 493
// module chunks = 0